<template>
    <div class="slider-cottage-listing">
                            <swiper-container :slides-per-view="1"
                                                :loop="true"
                                                init="false"
                                                :effect="getEffect"
                                                :ref="'swiper_'+item.ID"
                                                pagination="true"
                                                pagination-dynamic-bullets="true"
                                                @swiperslidechange="onSlideChange"
                                               
                                            >
                                            <swiper-slide v-for="(media, index) in allMedia" :key="media.mediaIndex + '-' + media.isVideo" lazy="true">
                                                <div class="gallery-one" :style="{'--sp-max-h': maxHeight+'px'}"  v-if="isSwiperInited">
                                                    <img v-if="!media.isVideo && (index === firstImageIndex || indexActive === index)" :src="media.src" :alt="item.NAME" :width="media.width" :height="media.height" loading="lazy">
                                                    <video v-if="media.isVideo" :ref="'videos'" muted playsinline preload="metadata" :src="media.src" :style="{width:'100%', height:'100%', objectFit:'cover'}" loading="lazy" :poster="getPlaceholderImage()"></video>

                                                    <!-- <div class="swiper-lazy-preloader"></div> -->
                                                </div>
                                            </swiper-slide>
                        
                                        </swiper-container>  

                                <div class="gallery-control" v-if="!isMobile">
                                    <div class="part-control"
                                        v-for="(media, index) in allMedia"
                                        :style="'width:'+widthControl+'%'"
                                        @mouseenter="hoverControlMedia(index, media, item)"
                                        :class="{active:media.active}"
                                        :key="'control-' + index"
                                        >

                                    </div>
                                </div>
       
    </div>
    
</template>  
<style>

.slider-cottage-listing swiper-container::part(bullet), .slider-cottage-listing swiper-container::part(bullet-active)
{
    border: 1px solid white;
    height: 6px;
    width: 6px;
    background: transparent;
    opacity: 1;
}

.slider-cottage-listing swiper-container::part(bullet-active)
{
    background: white;
    border: 0px solid white;
}


.slider-cottage-listing
{
    position: relative;
    border-radius: 12px;
    overflow: hidden;
}

.gallery-control
{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 7px;
    display: flex;
    justify-content: space-between;
    z-index: 88;
}

.part-control
{
    height: 100%;
    border-bottom: 1px solid #bebebe;
}

.part-control.active
{
    border-bottom: 2px solid #6d973e;
}

.gallery-one
{
    
}

.gallery-one
{
    max-height: var(--sp-max-h, none);
}

/* Планшет: высота слайда считается от ширины карточки — пропорция ресайза
   фото листинга 1308x981 (4:3). Фикс. 174px (десктоп) / 160px (<=1200)
   с объект-фитом cover срезали дом сверху и снизу; aspect-ratio показывает
   фото целиком на любом разрешении планшета, сетка остаётся ровной */
@media (min-width: 768px) and (max-width: 1200px)
{
    .slider-built-cottages__item .gallery-one
    {
        height: auto;
        max-height: none;
        aspect-ratio: 1308 / 981;
    }

    /* Листинг посёлков: фото ресайзятся в бокс 500x250 (~3:2) — высота
       от ширины карточки вместо полоски 160px. В панели карты правило
       style-tablet.css (своё 3:2 на колонку 40%) приоритетнее */
    .slider-villages .gallery-one
    {
        height: auto;
        max-height: none;
        aspect-ratio: 3 / 2;
    }
}

.gallery-one img, .gallery-one video
{
    object-fit: cover;
    max-height: 100%;
    position: absolute;
    height: 100%;
    z-index: 11;
}



</style> 

<script>


export default {name:"slider-photo",

                        props: [
                                'item',
                                'maxHeight',
                                'isPlaying'
                            ],
                        data:function(){

                            return {
                                        isSwiperInited: false,
                                        widthControl:0,
                                        indexActive:0,
                                        manualOverride:false,
                                        isSwitching:false,
                                        mobileSwiper:
                                        {
                                            breakpoints: {
                                                768: {

                                                    effect: "fade"

                                                }
                                            }
                                        }
                                    }
						
                        },
                        mounted() {
                            const swiperContainer = this.$refs['swiper_' + this.item.ID];
                            if (swiperContainer) {
                                const observer = new IntersectionObserver((entries) => {
                                    entries.forEach(entry => {
                                        if (entry.isIntersecting && !this.isSwiperInited) {
                                            //console.log(swiperContainer);
                                            this.isSwiperInited = true;
                                            this.$nextTick(() => {
                                                swiperContainer.initialize();
                                            });
                                            observer.disconnect();
                                        }
                                    });
                                }, {
                                    rootMargin: '50px 0px 50px 0px' // preload margin
                                });
                                observer.observe(this.$el);
                            }
                        },

                        created: function(){

                            this.widthControl = 100/this.allMedia.length;
                            //console.log("Мобильная:"+window.mobile);
                            //console.log(this.maxHeight);
                            this.videoEndedHandler = (loopNext) => {

                                if (window.bus) window.bus.$emit('videoEnded', { elementId: this.item.ID, loopNext });

                            }

                        },

                        computed: {

                            isMobile()
                            {
                                if(window.mobile)
                                {
                                    return true;
                                }
                                else
                                {
                                    return false;
                                }
                            },

                            getEffect()
                            {
                                if(window.mobile)
                                {
                                    return "slide";
                                }
                                else
                                {
                                    return "fade";
                                }
                            },

                            allMedia()
                            {
                                let media = [];
                                if (this.item.PROPS && this.item.PROPS.VIDEO_GALLERY) {
                                    this.item.PROPS.VIDEO_GALLERY.forEach((video, idx) => {

                                        console.log(video);
                                        media.push({ ...video, src: video.VALUE_FILE.src, isVideo: true, mediaIndex: idx });
                                    });
                                }
                                if (this.item.GALLERY) {
                                    this.item.GALLERY.forEach((photo, idx) => {
                                        media.push({ ...photo, isVideo: false, mediaIndex: idx });
                                    });
                                }
                                return media;
                            },

                            firstImageIndex()
                            {
                                return this.allMedia.findIndex(m => !m.isVideo);
                            }


                        },

                        watch:{

                            isPlaying: function() {

                                if (this.isPlaying && !this.isSwiperInited) {
                                    this.isSwiperInited = true;
                                    this.$nextTick(() => {
                                        const swiperContainer = this.$refs['swiper_' + this.item.ID];
                                        if (swiperContainer) swiperContainer.initialize();
                                    });
                                }

                                if (this.isPlaying) {

                                    this.controlVideos();

                                } else {

                                    this.pauseAllVideos();

                                }

                            }

                        },

						methods:{

                            onSlideChange(event)
                            {
                                //console.log(event.detail);
                               this.indexActive = event.detail[0].realIndex;
                               if (this.isPlaying) {
                                   this.controlVideos();
                               }

                            },

                            hoverControlMedia: function(index, media, item){
                                this.allMedia.forEach(element => {
                                    element.active = false;
                                });
                                this.$set(media, 'active', true);

                                // отмечаем ручное вмешательство, чтобы не прыгать назад на видео
                                this.manualOverride = true;

                                // стопаем текущее видео, чтобы не дергалось
                                this.pauseAllVideos();

                                // фиксируем активный индекс и двигаем слайд
                                this.indexActive = index;
                                this.$refs['swiper_'+item.ID].swiper.slideTo(index);

                                // если карточка сейчас в режиме автоплей — вызовем контроль (он отработает early-return на manualOverride)
                                if (this.isPlaying) {
                                    this.controlVideos();
                                }

                            },

                            getPlaceholderImage: function() {
                                return this.item.PREVIEW_PICTURE?.SRC || '';
                            },

                            pauseAllVideos: function() {
                                if (this.$refs.videos) {
                                    this.$refs.videos.forEach(video => {
                                        if (video) {
                                            video.pause();
                                            video.currentTime = 0;
                                        }
                                    });
                                }
                            },

                            controlVideos: function() {
                                if (!this.isPlaying) return;
                                if (!this.isSwiperInited) return;

                                // если вручную выбрали слайд — не автоплеим, но как только слайд станет видео — продолжим очередь
                                if (this.manualOverride) {
                                    const currentMediaManual = this.allMedia[this.indexActive];
                                    if (!currentMediaManual || !currentMediaManual.isVideo) {
                                        this.pauseAllVideos();
                                        return;
                                    }
                                    // если выбран видео-слайд, сбрасываем флаг и даём автоплею продолжить
                                    this.manualOverride = false;
                                }

                                // если текущий слайд не видео, переключаемся на первый видео-слайд
                                const currentMedia = this.allMedia[this.indexActive];
                                if (!currentMedia || !currentMedia.isVideo) {
                                    // на мобильном не дергаем слайдер, просто ставим на паузу
                                    if (this.isMobile) {
                                        this.pauseAllVideos();
                                        return;
                                    }

                                    const firstVideoIndex = this.allMedia.findIndex(m => m.isVideo);
                                    if (firstVideoIndex >= 0) {
                                        this.$refs['swiper_' + this.item.ID].swiper.slideTo(firstVideoIndex);
                                    }
                                    this.pauseAllVideos();
                                    return;
                                }

                                this.isSwitching = true;
                                this.$nextTick(() => {
                                    let videoIndex = -1;
                                    this.allMedia.forEach((media, idx) => {
                                        if (!media.isVideo) return;
                                        videoIndex++;
                                        const video = this.$refs.videos?.[videoIndex];
                                        if (!video) return;

                                        if (idx === this.indexActive) {
                                            video.onended = null;
                                            video.addEventListener('ended', () => this.videoEndedHandler(true), { once: true });
                                            video.currentTime = 0;
                                            // безопасный запуск без броска AbortError
                                            const p = video.play();
                                            if (p && typeof p.catch === 'function') {
                                                p.catch(() => {});
                                            }
                                        } else {
                                            video.pause();
                                            video.currentTime = 0;
                                        }
                                    });
                                    this.manualOverride = false;
                                    this.isSwitching = false;
                                });
                            },

                            hoverControlImage: function(index, photo, item){

                                item.GALLERY.forEach(element => {

                                    element.active = false;
                                });
                                //console.log("навели");
                                // console.log(photo);
                                this.$set(photo, 'active', true);

                                //photo.active = true;
                                //console.log(this.$refs);

                                //swiper.slideTo(index, speed, runCallbacks);
                                this.$refs['swiper_'+item.ID].swiper.slideTo(index);

                            },

						}

					}

</script>
